<template>
  <el-radio-group
    v-model="settings.use_whitelist_user_agents"
    @update:modelValue="update"
  >
    <div class="user-agents-wrap">
      <el-radio :value="true">
        <span>UserAgent white list</span>
        <TextAreaWithArray
          v-model="settings.whitelist_user_agents"
          :disabled="!settings.use_whitelist_user_agents"
          :rows="4"
          @update:modelValue="update"
        />
        <p class="hint">
          Allow traffic if user agents contains one of the substrings. One
          substring per line.
        </p>
      </el-radio>
    </div>
    <div class="user-agents-wrap">
      <el-radio :value="false">
        <span>UserAgent black list</span>
        <TextAreaWithArray
          v-model="settings.blacklist_user_agents"
          :disabled="settings.use_whitelist_user_agents"
          :rows="4"
          @update:modelValue="update"
        />
        <p class="hint">
          Disallow traffic if UserAgents contains one of the strings above. One
          substring per line.
        </p>
      </el-radio>
    </div>
  </el-radio-group>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue'
import TextAreaWithArray from '@/components/TextAreaWithArray.vue'

export default defineComponent({
  name: 'UserAgentFilter',
  components: {
    TextAreaWithArray
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },

  setup(props, context) {
    const settings = reactive({ ...props.modelValue })

    const update = () => {
      return context.emit('update:modelValue', {
        use_whitelist_user_agents: settings.use_whitelist_user_agents,
        whitelist_user_agents: settings.whitelist_user_agents,
        blacklist_user_agents: settings.blacklist_user_agents
      })
    }

    return { settings, update }
  }
})
</script>

<style lang="scss" scoped>
.user-agents-wrap {
  margin: 13px 5px 5px 5px;

  .el-textarea {
    margin-left: 5px;
    vertical-align: top;
    width: 450px;
  }

  .hint {
    line-height: 1.2;
    color: var(--el-text-color-secondary);
    margin-left: 142px;
  }
}
</style>
